var map = {
	"./breathe.jpg": 214,
	"./crypto.jpg": 354,
	"./demo.jpg": 870,
	"./journal.jpg": 3,
	"./lab.jpg": 235,
	"./miami.jpg": 470,
	"./tenzi.jpg": 918,
	"./trivia.jpg": 833,
	"./typing.jpg": 360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 605;